import PasswordResetContainer from "../components/pageComponents/Login/PasswordResetContainer";

const PasswordReset=()=>{
    return(
    <div><PasswordResetContainer /></div>);
}
export default PasswordReset;